// Self-registration validation (pure, shared by UI and the registerSelf Cloud Function).
export interface SignupInput { firstName: string; lastName: string; phone?: string; privacyConsent: boolean; marketingConsent: boolean; }
export type SignupError = 'FIRST_NAME_REQUIRED' | 'LAST_NAME_REQUIRED' | 'NAME_TOO_LONG' | 'PRIVACY_REQUIRED' | 'PHONE_INVALID';

export function validateSignup(i: Partial<SignupInput>): SignupError[] {
  const e: SignupError[] = [];
  if (!i.firstName?.trim()) e.push('FIRST_NAME_REQUIRED');
  if (!i.lastName?.trim()) e.push('LAST_NAME_REQUIRED');
  if ((i.firstName?.length ?? 0) > 60 || (i.lastName?.length ?? 0) > 80) e.push('NAME_TOO_LONG');
  if (i.privacyConsent !== true) e.push('PRIVACY_REQUIRED');
  if (i.phone && !/^\+[1-9]\d{6,14}$/.test(i.phone)) e.push('PHONE_INVALID');
  return e;
}

export const normaliseName = (s: string) => s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();

/** Prefix keys so "sil" finds "Ana Silva". */
export function searchKeys(first: string, last: string) {
  const keys = new Set<string>();
  for (const w of [first, last, ...last.split(/\s+/)]) { const n = normaliseName(w); for (let i = 2; i <= Math.min(n.length, 20); i++) keys.add(n.slice(0, i)); }
  return [...keys];
}
